import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './design/app.css';
// Registered at load: the browser's install event fires once, early.
import './mail/device';
import { App } from './App';

const root = document.getElementById('root');
if (!root) {
	throw new Error('#root missing from index.html');
}

createRoot(root).render(
	<StrictMode>
		<App />
	</StrictMode>
);
